<ng-container *ngIf="form?.getError('invalidPassword')">
    {{ 'asset_username_changed_warning' | translate }}
</ng-container>
<ng-container *ngIf="!control?.pristine &&
                    control?.getError('password.maxlength') &&
                    control?.getError('password.maxlength')">
    {{ 'asset_password_max_warning' | translate:control?.getError('password.maxlength') }}
</ng-container>
